function r(n) {
  const e = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return e[t] || (e[t] = n(t));
  };
}
const o = /\B([A-Z])/g, a = r(
  (n) => n.replace(o, "-$1").toLowerCase()
), c = /-(\w)/g, f = r((n) => n.replace(c, (e, t) => t ? t.toUpperCase() : "")), y = r(
  (n) => n.charAt(0).toUpperCase() + n.slice(1)
);
function i(n) {
  return typeof n == "string";
}
function s(n) {
  return typeof n == "number" && u(n);
}
function u(n) {
  return Number.isFinite(n);
}
Object.getPrototypeOf(async function() {
}).constructor;
function h(n, e = "px") {
  if (n == null)
    return `0${e}`;
  if (i(n))
    return n;
  if (s(n))
    return `${n}${e}`;
}
function l() {
  return Date.now();
}
function w(n) {
  return Reflect.ownKeys(n);
}
export {
  l as now,
  w as ownKeys,
  a as parseCamelizeToHyphenate,
  y as parseCapitalize,
  f as parseHyphenateToCamelize,
  h as parseUnit
};
//# sourceMappingURL=utils.js.map
